<template>
    <div class="mt--1 pb-4">
        <b-tabs
            vertical
            pills
            nav-wrapper-class="col-12 nav-pills-custom mb-1 col-md-3 left-tab"
            content-class="col-md-9 col-lg right-tab "
            v-model="tabIndex"
        >
            <b-tab title-item-class="mb-1" @click="triggerResizeEvent">
                <template #title>
                    <div
                        class="py-md-4 text-center"
                        id="v-pills-home-tab"
                        data-toggle="pill"
                        role="tab"
                        aria-controls="v-pills-home"
                        aria-selected="true"
                    >
                        <div class="dis-block">
                            <img src="@/assets/images/icon/tab_location.svg" />
                        </div>
                        <div class="dis-none">
                            <img
                                src="@/assets/images/icon/tab_location-w.svg"
                            />
                        </div>
                        <span class="small">{{ $translate('map') }}</span>
                    </div>
                </template>
                <b-overlay rounded="lg">
                    <div
                        class="tab-pane fade shadow rounded bg-white py-2 active show"
                    >
                        <b-col md="12" class="mt-2 mb-2">
                            <officers-map
                                key="officerMap"
                                :geojson="geojson"
                                :loaded="isLoaded"
                                :officers="officers"
                                :roles="roles"
                            />
                        </b-col>
                        <b-col md="12" class="mb-2">
                            <asset-map
                                key="AssetMap"
                                :geojson="geojson"
                                :loaded="isLoaded"
                                :assets="assets"
                                :asset-types="assetTypes"
                            />
                        </b-col>
                    </div>
                    <div class="border-bar"></div>
                </b-overlay>
            </b-tab>
            <b-tab title-item-class="mb-1">
                <template #title>
                    <div
                        class="py-md-4 text-center"
                        id="v-pills-profile-tab"
                        data-toggle="pill"
                        role="tab"
                        aria-controls="v-pills-profile"
                        aria-selected="false"
                    >
                        <div class="dis-none">
                            <img src="@/assets/images/icon/tab_customer.svg" />
                        </div>
                        <div class="dis-block">
                            <img
                                src="@/assets/images/icon/tab_customer-w.svg"
                            />
                        </div>
                        <span class="small">{{ $translate('ratings') }}</span>
                    </div>
                </template>
                <b-overlay rounded="lg">
                    <div
                        class="tab-pane fade shadow rounded overflow-auto bg-white py-2 active show"
                    >
                        <customer-charts
                            :officers="officers"
                            :roles="roles"
                            :orders="orders"
                            :order-types="orderTypes"
                        ></customer-charts>
                    </div>
                    <div class="border-bar"></div>
                </b-overlay>
            </b-tab>
            <b-tab title-item-class="mb-1">
                <template #title>
                    <div
                        class="py-md-4 text-center"
                        id="v-pills-messages-tab"
                        data-toggle="pill"
                        role="tab"
                        aria-controls="v-pills-messages"
                        aria-selected="false"
                    >
                        <div class="dis-none">
                            <img src="@/assets/images/icon/tab_analytics.svg" />
                        </div>
                        <div class="dis-block">
                            <img
                                src="@/assets/images/icon/tab_analytics-w.svg"
                            />
                        </div>
                        <span class="small">{{
                            $translate('activity_analytics')
                        }}</span>
                    </div>
                </template>
                <b-overlay :show="!isLoaded" rounded="lg">
                    <div
                        class="tab-pane fade shadow rounded bg-white py-2 active show"
                    >
                        <!-- <template v-if="tabIndex === 2"> -->
                            <analytics-charts
                            :officers="officers"
                            :roles="roles"
                            :orders="orders"
                            :order-types="orderTypes"
                            ></analytics-charts>
                        <!-- </template> -->
                    </div>
                    <div class="border-bar"></div>
                </b-overlay>
            </b-tab>
            <b-tab @click="triggerResizeEvent">
                <template #title>
                    <div
                        class="py-md-4 text-center"
                        id="v-pills-messages-tab"
                        data-toggle="pill"
                        role="tab"
                        aria-controls="v-pills-messages"
                        aria-selected="false"
                    >
                        <div class="dis-none">
                            <img src="@/assets/images/icon/scheduling.svg" />
                        </div>
                        <div class="dis-block">
                            <img src="@/assets/images/icon/scheduling-w.svg" />
                        </div>
                        <span class="small">{{
                            $translate('scheduling')
                        }}</span>
                    </div>
                </template>
                <b-overlay rounded="lg">
                    <dashboard-schedule
                        :officers="officers"
                        :roles="roles"
                        :crm-setting-value="crmSettingValue"
                        :user="user"
                    ></dashboard-schedule>
                </b-overlay>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import layoutMixins from '../mixins/layoutMixins'
import { capitalCase } from 'change-case'
import OfficersMap from './Dashboard/OfficersMap'
import AssetMap from './Dashboard/AssetMap'
import CustomerCharts from './Dashboard/CustomerCharts.vue'
import AnalyticsCharts from './Dashboard/AnalyticsCharts.vue'
import DashboardSchedule from './Dashboard/DashboardSchedule.vue'
import jamaica_parishes_geojson from '../exports/geoserver-GetFeature.json'

export default {
    name: 'Analytics',
    components: {
        OfficersMap,
        AssetMap,
        DashboardSchedule,
        CustomerCharts,
        AnalyticsCharts,
    },
    mixins: [layoutMixins],
    data() {
        return {
            geojson: jamaica_parishes_geojson,
            tabIndex: 0,
            toggleFeedback: true,
            selectedType: null,
            isMounted: false,
        }
    },

    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },

    computed: {
        isLoaded() {
            return !!(this.isMounted && !this.analyticsDataLoading)
        },
        analyticsDataLoading() {
            return this.$store.state.analytics.analyticsDataLoading
        },
        size() {
            return this.idx < this.statPaths.length - 1
                ? parseInt(12 / this.statPaths.length)
                : ''
        },
        filteredOfficers() {
            return this.officers
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        officers() {
            return this.$store.getters['analytics/officers']
        },
        crmSettingValue() {
            return this.$store.getters['company/crmSettingValue']
        },
        user() {
            return this.$store.state.user || {}
        },
        roles() {
            return this.$store.getters['analytics/roles']
        },
        assets() {
            return this.$store.getters['analytics/assets']
        },
        assetTypes() {
            return this.$store.getters['analytics/assetTypes']
        },
        orders() {
            console.log(
                " this.$store.getters['analytics/orders']",
                this.$store.getters['analytics/orders']
            )
            return this.$store.getters['analytics/orders'] || []
        },

        orderTypes() {
            return this.$store.getters['analytics/orderTypes']
        },
    },

    watch: {
        isLoaded: function (val) {
            console.log('analyticsDataLoading:', this.analyticsDataLoading)
            console.log('isMounted:', this.isMounted)
            console.log('isLoaded:', val)
        },
        tabIndex: function (val) {
            if (val == 2 && this.orders.length === 0) this.$store.dispatch('analytics/getOrderAnalytics')
        },
    },
    created() {
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('company/fetch')
        this.$store.dispatch('analytics/getAnalytics')
    },
    mounted() {
        this.isMounted = true
    },
    methods: {
        triggerResizeEvent() {
            window.dispatchEvent(new Event('resize'))
        },
    },
}
</script>
<style scoped>
.row.no-gutters {
    margin-right: 0;
    margin-left: 0;
}
</style>
